import {Component, Vue, Prop} from 'vue-property-decorator'
import {repositories} from "@service/api/Repositories";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import { UserRepository } from "@api/repositories/UserRepository";
import { FileRepository } from "@api/repositories/FileRepository";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import {Problem} from "@api/models/tickets/Problem";
import {Idea} from "@api/models/tickets/Idea";
import {TicketEditFormSelectSources} from "@share/ticketSystem/components/types";
import { getRiskLevelSource, getRiskLevelSourceFull, getTicketFormSelectSources} from "@share/ticketSystem/components/data";
import {UserProfile} from "@api/models/UserProfile";
import {FilesPayload, FileValue} from "@share/common/form/form-controls/file/DragNDrop.vue";
import { SelectObjectSourceService } from "@share/common/services/selectControl/SelectObjectSourceService";
import {DropDownItem} from "@share/common/drop-down/types";
import {UnloadService} from "@share/common/services/unloadService/UnloadService"
import {AppercodeFile} from "@api/models/File";
import { dateToFormatFromIso, dateFromFormatToIso } from "@common/dateTimeHelper";
import {DateTime} from "luxon";
import {RouteNamesEnum} from "@service/router/RouteNamesEnum";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";
import { Debounce } from "vue-debounce-decorator";
import Axios, { CancelTokenSource } from 'axios';
import { TicketFormParams } from "@share/ticketSystem/components/data";
import { getUserInfoForSelectTitle } from "@share/common/helpers/userProfileNameHelper";
import { prepareProfileFilter } from '@api/helpers/profileSearch';

@Component
class TicketFormMixin extends Vue {
    @Prop({ required: true }) params: TicketFormParams;
    @Prop({default: true }) selfAdminPanelHandling: boolean;

    private formatDate = 'yyyy-LL-dd';
    private companySchemaId = 'CompanyStructure';

    ticket?: Problem | Idea | null = null;
    ticketOriginal: Problem | Idea | null = null;
    refTicketData: any;
    searchedSources: TicketEditFormSelectSources = getTicketFormSelectSources();
    selectedListSources: TicketEditFormSelectSources = getTicketFormSelectSources();

    riskLevelSelectSource: DropDownItem<string>[] = getRiskLevelSource();
    riskLevelSourceFull: DropDownItem<string>[] = getRiskLevelSourceFull();

    users: UserProfile[] = [];
    fileIdsValue: FilesPayload = [];
    imageFileIdsValue: FilesPayload = [];

    notFoundError = false;
    isLoading = true;
    selectSourceService: SelectObjectSourceService | null = null;
    unloadService: UnloadService | null = null;
    resetable = false;
    rightSideStyle: string | null = null;
    usersSearchcancelToken: CancelTokenSource | null = null;
    toggleOptions = {
        handle: {
            diameter: 17,
            distance: 40
        },
        track: {
            activeColor: "#4CD964",
            width: 32,
            height: 19
        }
    }

    get fileIds() {
        return this.fileIdsValue;
    }

    set fileIds(value) {
        this.setFilesForField('fileIds', 'fileIdsValue', value);
    }

    get imageFileIds() {
        return this.imageFileIdsValue;
    }

    set imageFileIds(value) {
        this.setFilesForField('imageFileIds', 'imageFileIdsValue', value);
    }

    get objectRepository() {
        return repositories.get<ObjectRepository>(RepositoryFabric.OBJECT);
    }

    get userRepository() {
        return repositories.get<UserRepository>(RepositoryFabric.USER);
    }

    get fileRepository() {
        return repositories.get<FileRepository>(RepositoryFabric.FILE);
    }

    get updatedBy() {
        if (this.users && this.ticket?.updatedBy) {
            let updatedBy = this.ticket.updatedBy;
            return this.users.find((item: UserProfile) => item.userId == updatedBy) || null;
        }
        return null;
    }

    get updatedAt() {
        if (this.ticket?.updatedAt) {
            return this.ticket.updatedAt.toLocaleString() + ',';
        }
        return '';
    }

    get implementationDate() {
        if (this.ticket?.implementationDate) {
            return dateToFormatFromIso(this.ticket.implementationDate, this.formatDate);
        }
        return '';
    }

    set implementationDate(value: string) {
        if (this.ticket) {
            Vue.set(this.ticket, 'implementationDate', dateFromFormatToIso(value, this.formatDate));
        }
    }

    get implementedAt() {
        if (this.ticket?.implementedAt) {
            return dateToFormatFromIso(this.ticket.implementedAt, this.formatDate);
        }
        return '';
    }

    set implementedAt(value: string) {
        if (this.ticket) {
            Vue.set(this.ticket, 'implementedAt', dateFromFormatToIso(value, this.formatDate));
        }
    }

    get publishedAt() {
        if (this.ticket?.publishedAt) {
            return dateToFormatFromIso(this.ticket.publishedAt, this.formatDate);
        }
        return '';
    }

    set publishedAt(value: string) {
        if (this.ticket) {
            Vue.set(this.ticket, 'publishedAt', dateFromFormatToIso(value, this.formatDate));
        }
    }

    get plannedImplementationDate() {
        if (this.ticket?.plannedImplementationDate) {
            return dateToFormatFromIso(this.ticket.plannedImplementationDate, this.formatDate);
        }
        return '';
    }

    set plannedImplementationDate(value: string) {
        if (this.ticket) {
            Vue.set(this.ticket, 'plannedImplementationDate', dateFromFormatToIso(value, this.formatDate));
        }
    }

    get committeeReviewedAt() {
        if (this.ticket?.committeeReviewedAt) {
            return dateToFormatFromIso(this.ticket.committeeReviewedAt, this.formatDate);
        }
        return '';
    }

    set committeeReviewedAt(value: string) {
        if (this.ticket) {
            Vue.set(this.ticket, 'committeeReviewedAt', dateFromFormatToIso(value, this.formatDate));
        }
    }

    get bigCommitteeReviewedAt() {
        if (this.ticket?.bigCommitteeReviewedAt) {
            return dateToFormatFromIso(this.ticket.bigCommitteeReviewedAt, this.formatDate);
        }
        return '';
    }

    set bigCommitteeReviewedAt(value: string) {
        if (this.ticket) {
            Vue.set(this.ticket, 'bigCommitteeReviewedAt', dateFromFormatToIso(value, this.formatDate));
        }
    }


    get categoryId(): DropDownItem {
        return this.selectedListSources.categories.find((item) => item.id === this.ticket?.category) || {
            title: "",
            id: this.ticket?.category
        }
    }

    set categoryId(value: DropDownItem) {
        this.selectedListSources.categories = [value];
        if (this.ticket) {
            this.ticket.category = value.id || null;
        }
    }

    get categoriesSource() {
        return this.searchedSources.categories;
    }

    public get riskLevel(): DropDownItem<string> {
        return { title: this.ticket?.riskLevel || "", id: "" };
    }

    public set riskLevel(value: DropDownItem<string>) {
        if(this.ticket) {
            this.ticket.riskLevel = (this.riskLevelSelectSource.find((item) => item.id === value.id) || { title: this.ticket?.riskLevel || "", id: "" }).title;
        }
    }

    get statusId(): DropDownItem {
        let item: DropDownItem = this.selectedListSources.statuses.find((item) => item.id === this.ticket?.status) || {
            title: "",
            id: this.ticket?.status
        }
        if (this.vTicket?.status) {
            this.vTicket.status.$model = item.id;
        }
        return item;
    }

    set statusId(value: DropDownItem) {
        this.selectedListSources.statuses = [value];
        if (this.ticket) {
            this.ticket.status = value.id || null;
            if (this.vTicket?.status) {
                this.vTicket.status.$model = this.ticket.status;
            }
        }
    }

    get statusesSource() {
        return this.searchedSources.statuses;
    }

    get companyId(): DropDownItem {
        return this.selectedListSources.companies.find((item) => item.id === this.ticket?.company) || {
            title: "",
            id: this.ticket?.company
        }
    }

    set companyId(value: DropDownItem) {
        this.selectedListSources.companies = [value];
        if (this.ticket) {
            this.ticket.company = value.id || null;
        }
    }

    get responsibleUserId(): DropDownItem {
        if (this.ticket) {
            let userId = '';
            if (this.ticket.responsibleUserId) {
                userId = this.ticket.responsibleUserId.toString();
            }
            return this.selectedListSources.responsibleUser.find((item) => item.id === userId) || {
                title: "",
                id: userId
            }
        }
        return {
            title: "",
            id: ""
        }
    }

    set responsibleUserId(value: DropDownItem) {
        this.selectedListSources.responsibleUser = [value];
        if (this.ticket && value && Object.prototype.hasOwnProperty.call(value, 'id') && value.id !== undefined) {
            this.ticket.responsibleUserId = value.id ? parseInt(value.id) : null;
            if (this.vTicket && this.vTicket.responsibleUserId) {
                this.vTicket.responsibleUserId.$model = this.ticket.responsibleUserId;
            }
        }
    }

    get responsibleForImplementationUserId(): DropDownItem {
        if (this.ticket) {
            let userId = this.ticket.responsibleForImplementationUserId ? this.ticket.responsibleForImplementationUserId.toString() : '';
            return this.selectedListSources.responsibleForImplementationUser.find((item) => item.id === userId) || {
                title: "",
                id: userId
            }
        }
        return {
            title: "",
            id: ""
        }
    }

    set responsibleForImplementationUserId(value: DropDownItem) {
        this.selectedListSources.responsibleForImplementationUser = [value];
        if (this.ticket) {
            if (value.id) {
                this.ticket.responsibleForImplementationUserId = parseInt(value.id) || null;
            } else {
                this.ticket.responsibleForImplementationUserId = null;
            }
        }
    }

    @Debounce(350)
    async usersSearch(keyword = "") {
        if(!keyword.length) {
            this.searchedSources.users = [];
        }

        if(keyword.length < 2) {
            return
        }

        if (this.usersSearchcancelToken) {
            this.usersSearchcancelToken.cancel();
        }

        this.usersSearchcancelToken = Axios.CancelToken.source();

        try {
            const where = prepareProfileFilter({
                searchStr: keyword,
                additionalFields: ['middleName'],
            });

            let users: UserProfile[] = await this.userRepository.profiles({
                include: ['userId', 'firstName', 'lastName', 'direction', 'position'],
                where: where,
                take: 30,
                order: [
                    {
                        column: 'firstName',
                        direction: 'asc'
                    }
                ],
            }, { cancelToken: this.usersSearchcancelToken.token }) || [];
            if (users.length) {
                this.searchedSources.users = users.map((user) => {

                    const title = getUserInfoForSelectTitle(user, "direction");

                    return {
                        id: user.userId ? user.userId.toString() : '',
                        title: title
                    }
                });
            }
        }
        catch(e) {
            this.$store.dispatch("reportError", e);
        }
    }

    get usersSource() {
        return this.searchedSources.users;
    }

    get directionId(): DropDownItem {
        return this.selectedListSources.directions.find((item) => item.id === this.ticket?.direction) || {
            title: "",
            id: this.ticket?.direction
        }
    }

    set directionId(value: DropDownItem) {
        this.selectedListSources.directions = [value];
        if (this.ticket) {
            this.ticket.direction = value.id || null;
        }
    }

    get directionsSource() {
        return this.searchedSources.directions;
    }

    get branchId(): DropDownItem {
        return this.selectedListSources.branches.find((item) => item.id === this.ticket?.branch) || {
            title: "",
            id: this.ticket?.branch
        }
    }

    set branchId(value: DropDownItem) {
        this.selectedListSources.branches = [value];
        if (this.ticket) {
            this.ticket.branch = value.id || null;
        }
    }

    @Debounce(350)
    async directionsSearch(keyword = "") {
        this.searchedSources.directions = await this.searchForSelect(this.companySchemaId, keyword);
    }

    @Debounce(350)
    async companiesSearch(keyword = "") {
        this.searchedSources.companies = await this.searchForSelect(this.companySchemaId, keyword);
    }

    @Debounce(350)
    async branchesSearch(keyword = "") {
        this.searchedSources.branches = await this.searchForSelect(this.companySchemaId, keyword);
    }

    private async searchForSelect(schemaId: string, keyword = "") {
        try  {
            return await this.selectSourceService?.getSelectSource({ keyword, schemaId }) || [];
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
            return [];
        }
    }

    get branchesSource() {
        return this.searchedSources.branches;
    }

    get vTicket() {
        return this.$v.ticket
    }

    /**
     * TODO: BAD METHOD
     * @param ticketFieldName
     * @param fieldName
     * @param value
     */
    async setFilesForField(ticketFieldName: string, fieldName: string, value: any) {
        // TODO: REMOVE THIS!
        let self: any = Object.assign(this, {});

        try {
            if (this.ticket && value && Array.isArray(value) && value.length) {
                let fileIds: string[] = [];

                if (Array.isArray(this.ticket[ticketFieldName])) {
                    fileIds = this.ticket[ticketFieldName];
                }

                let promises: Promise<AppercodeFile>[] = value.map(
                    (file) => this.fileRepository.create(file.file, file.file.name)
                );

                (await Promise.all(promises)).forEach((fileUpload) => {
                    if (fileUpload && fileUpload.id) {
                        fileIds.push(fileUpload.id);
                    }
                })

                if (this.ticket && fileIds.length) {
                    this.ticket[ticketFieldName] = fileIds;
                    //TODO: replace this method to getFilesByIds(ids)
                    this.getFilesForField(ticketFieldName)
                        .then(files => {
                            if (Object.prototype.hasOwnProperty.call(self, fieldName)) {
                                self[fieldName] = files;
                            }
                        });
                }
            }
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
    }

    async getFilesByIds(ids: string[]): Promise<FilesPayload> {
        return (await this.fileRepository.query({ ids })).map((file) => ({ file }));
    }

    async getFilesForField(fieldName: string) {
        let files: FilesPayload = [];
        if (this.ticket && this.ticket[fieldName]) {

            if (Array.isArray(this.ticket[fieldName]) && !this.ticket[fieldName].length) {
                return files;
            }

            const filesFromServer = await this.fileRepository.query({ids: this.ticket[fieldName]})

            filesFromServer?.forEach((file: AppercodeFile) => {
                files.push({ file, url: '' });
            });
        }

        return files;
    }

    deleteFile(fileValue: FileValue | null, fieldName: string) {
        // TODO: REMOVE THIS!
        let self: any = Object.assign(this, {});
        const file = fileValue?.file;

        // TODO: remove fieldName + 'Value'

        if (this.ticket && file && Object.prototype.hasOwnProperty.call(self, fieldName + 'Value')) {

            self[fieldName + 'Value'] = self[fieldName].filter((fileItem: FileValue) => {
                return fileItem.file.id != file.id
            });

            this.ticket[fieldName] = this.ticket[fieldName].filter((fileId: string) => {
                return fileId != file.id
            });

            if (Array.isArray(this.ticket[fieldName]) && !this.ticket[fieldName].length) {
                this.ticket[fieldName] = null;
            }
        }
    }

    setCanBeReplicated(value: boolean) {
        if (this.ticket) {
            this.ticket.canBeReplicated = value;

            if (this.ticket.canBeReplicated) {
                this.publishedAt = DateTime.local().toFormat('yyyy-LL-dd');
            } else if (this.ticketOriginal && this.ticketOriginal.publishedAt) {
                this.publishedAt = dateToFormatFromIso(this.ticketOriginal.publishedAt, this.formatDate);
            }
        }
    }

    setHasBigEffect(value: boolean) {
        if (this.ticket) {
            this.ticket.hasBigEffect = value;
        }
    }

    setIsAnonymous(value: boolean) {
        if (this.ticket) {
            this.ticket.isAnonymous = value;
        }
    }

    show404() {
        this.notFoundError = true;
    }

    back() {
        if (this.selfAdminPanelHandling) {
            let toRoute;
            if (this.ticket?.id) {
                toRoute = this.ticketType === TicketType.idea ?
                    RouteNamesEnum.ticketSystemIdeaView :
                    RouteNamesEnum.ticketSystemProblemView;

            } else {
                toRoute = this.ticketType === TicketType.idea ?
                    RouteNamesEnum.ticketSystemIdeas :
                    RouteNamesEnum.ticketSystemProblems;
            }

            this.$router.push({
                name: toRoute,
                hash: this.$route.hash,
                params: {
                    backend: this.$route.params.backend,
                    id: this.$route.params.id
                }
            });
        }
        else {
            this.$emit('back');
        }
    }

    getUserTitleForSelect(profile: UserProfile) {
        return getUserInfoForSelectTitle(profile, "direction");
    }

    get ticketType() {
        return this.params.ticketsType;
    }

    get ticketService() {
        return this.params.ticketService
    }

    get isAdmin() {
        return !!this.ticketService?.isAdmin;
    }

    get controlHelpMessage() {
        return this.$t('common.enterForSearch').toString()
    }
}

export default TicketFormMixin
